
export const formatTrades = (trade) => {
    if(trade){
        return trade.replace(/,/g, ', ');
    } else {
        return ""
    }

}